import React, {
    useState,
    useRef,
    useCallback,
    Fragment,
    useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../Functions';
import '../../../css/Ticketing.css';
import Pagination from '../../../../components/bronson/Pagination';

const CustomTable = ({
    FormatStatus,
    openDetailTicket,
    list,
    isLoading,
    //amountToRender = 4,
    headers,
    parentCurrentPage,
    isMobile,
    limitVehicles,
    lastNumberTicket,
    setCurrentPage,
    valueChanging = 0,
    itemKey,
    ...rest
}) => {
    const [optionsPagination, setOptionsPagination] = useState({
        currentPage: parentCurrentPage ? parentCurrentPage : 1,
        totalRecords: lastNumberTicket ? lastNumberTicket : 0,
        pageLimit: limitVehicles ? limitVehicles : 10,
        pageNeighbours: 0,
    });

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [list]);

    useEffect(() => {
        setOptionsPagination(currentOptions => ({
            ...currentOptions,
            currentPage: parentCurrentPage,
        }));
    }, [parentCurrentPage]);

    useEffect(() => {
        setOptionsPagination(currentOptions => ({
            ...currentOptions,
            totalRecords: lastNumberTicket,
        }));
    }, [lastNumberTicket]);

    const onPageChanged = page => {
        setCurrentPage(page);
        // changeParentCurrentPage(page);
    };

    const FormatDescr = desShort => {
        let Max_lenght = 16;
        if (desShort.length > Max_lenght) {
            return desShort.substring(0, Max_lenght - 2) + '...';
        } else {
            return desShort;
        }
    };

    const openDetail = e => {
        let detailTicket = {
            IdTicket: e.IdTicket,
            Status: e.DesEstado,
            Plate: e.Matricula,
            Date: e.FechaAlta,
            OpFinan: e.Contrato,
            Conces: e.NomConcesSolicitante,
            Solicitante: e.NomUsuarioAlta,
            Gestor: e.NomGestor,
            TelfGestor: '',
            EmailGestor: e.EmailGestor,
            TipoTicket: e.DescTipoTicket,
            DescrShort: e.DescripcionCorta,
            DescrLong: e.DescripcionLarga,
            Resolucion: e.resolucionTicket,
            DateEnd: e.DateEnd,
        };
        openDetailTicket(true, detailTicket);
    };

    const renderListContent = useCallback(
        () =>
            list.map((e, i) => {
                if (e.FechaAlta.indexOf('/') === -1) {
                    e.FechaAlta = formatDate(e.FechaAlta);
                }
                if (e.DateEnd !== null && e.DateEnd.indexOf('/') === -1) {
                    e.DateEnd = formatDate(e.DateEnd);
                }
                let estado = FormatStatus(e.DesEstado);
                let descShort = FormatDescr(e.DescripcionCorta);
                let UserName = FormatDescr(e.NomUsuarioAlta);
                let ConcesName = FormatDescr(e.NomConcesSolicitante);

                let classExtraTooltipDesc = '';
                let classExtraTooltipUser = '';
                let classExtraTooltipConces = '';
                descShort = descShort.toLowerCase();
                if (descShort.indexOf('...') !== -1)
                    classExtraTooltipDesc = ' js-tooltip c-tooltip ';
                UserName = UserName.toLowerCase();
                if (UserName.indexOf('...') !== -1)
                    classExtraTooltipUser = ' js-tooltip c-tooltip ';
                ConcesName = ConcesName.toLowerCase();
                if (ConcesName.indexOf('...') !== -1)
                    classExtraTooltipConces = ' js-tooltip c-tooltip ';

                let ClassColunFixed = isMobile
                    ? 'c-column_table_fixed'
                    : 'c-column_table_fixed_mobile';
                let ClassDetailBtn = isMobile
                    ? 'c-ticket_detail_button'
                    : 'c-ticket_detail_button_mobile';
                return (
                    <tr
                        key={'body_' + e.IdTicket}
                        className="u-body_table_ticket "
                    >
                        <td
                            className={
                                'c-ticket_fixed_column ' + ClassColunFixed
                            }
                        >
                            <button
                                className={
                                    'c-input__addon c-input__addon--no-background ' +
                                    ClassDetailBtn
                                }
                                onClick={() => openDetail(e)}
                            >
                                <i
                                    className="c-icon c-icon--small c-icon--[control-eye]"
                                    aria-hidden="true"
                                    role="img"
                                ></i>
                            </button>
                        </td>

                        <td>{e.IdTicket}</td>
                        <td>{e.Matricula}</td>
                        <td>{e.FechaAlta}</td>
                        <td>{estado}</td>
                        <td
                            className={`${classExtraTooltipDesc} c-tooltip_decoration_ticket  u-ticket_short_description `}
                            data-tippy-content={e.DescripcionCorta}
                            data-tippy-allowHTML="false"
                            data-tippy-placement="top"
                        >
                            {descShort}
                        </td>
                        <td
                            className={`${classExtraTooltipUser} c-tooltip_decoration_ticket u-ticket_name u-string_capitalize`}
                            data-tippy-content={e.NomUsuarioAlta}
                            data-tippy-placement="top"
                        >
                            {UserName}
                        </td>
                        <td
                            className={`${classExtraTooltipConces} c-tooltip_decoration_ticket  tu-ticket_name u-string_capitalize`}
                            data-tippy-content={e.NomConcesSolicitante}
                            data-tippy-placement="top"
                        >
                            {ConcesName}
                        </td>
                        <td>{e.Contrato}</td>
                    </tr>
                );
            }),
        [list, limitVehicles, rest, itemKey]
    );

    return (
        <Fragment>
            <div className="u-outer_table_ticket">
                <div className="u-inner_table_ticket">
                    <table className="c-table_search_ticketing">
                        <thead>
                            <tr>
                                {headers.map((e, i) => {
                                    if (i === 0) {
                                        return (
                                            <th
                                                key={i}
                                                className="u-head_table_ticket_color c-ticket_detail_button c-ticket_fixed_column"
                                            >
                                                {e}
                                            </th>
                                        );
                                    } else {
                                        let classLong =
                                            'u-head_table_ticket_short';
                                        if (i === 3)
                                            classLong =
                                                ' u-head_table_ticket_middle';
                                        if (i >= 4)
                                            classLong =
                                                ' u-head_table_ticket_long';
                                        return (
                                            <th
                                                key={i}
                                                className={`c-ticket_no_fixed_column u-head_table_ticket_color ${classLong}`}
                                            >
                                                {e}
                                            </th>
                                        );
                                    }
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {list !== undefined ? renderListContent() : null}
                        </tbody>
                    </table>
                </div>
                <div className="c_ticketing-pagination">
                    <Pagination
                        options={optionsPagination}
                        onPageChanged={onPageChanged}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </Fragment>
    );
};

CustomTable.propTypes = {
    openDetailTicket: PropTypes.any,
    list: PropTypes.arrayOf(PropTypes.object),
    valueChanging: PropTypes.any,
    headers: PropTypes.arrayOf(PropTypes.string).isRequired,
    FormatStatus: PropTypes.any,
};

export default CustomTable;
